import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Loader } from "./Loader";

export const ProtectedRoute = ({ children, adminOnly = false, ownerOnly = false, businessOnly = false, nhlOnly = false }) => {
    const { user, loading, hasAdminAccess, isOwner, isBusiness, canNhl } = useAuth();
    const location = useLocation();
    if (loading) return <Loader label="Checking session" />;
    // NHL pages are fully public — no login required.
    if (nhlOnly) return children;
    if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
    if (ownerOnly && !isOwner) return <Navigate to="/" replace />;
    if (adminOnly && !hasAdminAccess) return <Navigate to="/" replace />;
    if (businessOnly && !isBusiness) return <Navigate to="/" replace />;
    return children;
};

export default ProtectedRoute;
